import { useLocation, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import API_URL from "../config";
export const api = axios.create({ baseURL: API_URL });

export default function SubscriptionExpired() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const next = params.get("next") || "/";

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    navigate("/company-selection");
  };

// api.interceptors.response.use(
//   r => r,
//   err => {
//     if (err?.response?.status === 402) {
//       const next = window.location.pathname + window.location.search;
//       window.location.assign(`/billing/expired?next=${encodeURIComponent(next)}`);
//     }
//     return Promise.reject(err);
//   }
// );
  return (
    <div className="min-h-screen grid place-items-center bg-background px-4 overflow-x-hidden">
      <div className="card max-w-md w-full p-6 text-center">
        <h1 className="text-2xl font-bold mb-2">Your subscription has expired</h1>
        <p className="text-gray-600 mb-4">
          To continue using the app, please renew your subscription.
        </p>

        <div className="space-y-3">
          <Link to="/enquiry" className="primary-btn w-full py-3">
            Renew now
          </Link>

          {/* Optional: allow returning after payment */}
          <button
            onClick={() => navigate(next)}
            className="secondary-btn w-full py-3"
          >
            Go back
          </button>

          <button
            type="button"
            onClick={handleLogout}
            className="text-sm text-gray-500 underline"
          >
            Log out
          </button>
        </div>

        <p className="text-xs text-gray-400 mt-4">
          Need help? Contact support.
        </p>
      </div>
    </div>
  );
}
